import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import SelfContainedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/SelfContainedTabs';
import { getActiveSection } from '../../../../selectors/studio';
import { StudioSection } from '../../../../types/store';
import StudioHeading from '../../../StudioHeading';
import BaseHeader from '../BaseHeader';

import s from './OrdersHeader.scss';

export interface Props {
  className?: string;
}

const OrdersHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  const activeSection = useSelector(getActiveSection);
  const activeTab =
    activeSection === StudioSection.ORDERS_STATUS ? 'status' : 'originals';
  const tabs = [
    {
      index: 'status',
      label: 'Status',
      href: Url.studio({ section: 'orders-status' }),
    },
    {
      index: 'originals',
      label: 'Original Offerings',
      href: Url.studio({ section: 'orders-originals' }),
    },
  ];

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <StudioHeading>{t('studio.header.orders.title')}</StudioHeading>
      }
      middleSlot={
        <div className={s['tabs']}>
          {t('studio.header.orders.tabsPrefix')}
          <SelfContainedTabs items={tabs} activeIndex={activeTab} />
        </div>
      }
    />
  );
};
OrdersHeader.displayName = 'OrdersHeader';

export default OrdersHeader;
